import { CSSValue } from 'library/ts/ui/enums/css/CSSValue';
export class LoadingAnimationTimeoutMessage {
    #enabled;
    #config;
    #utils;
    #container;
    #loadingAnimationContainer;
    #bufferTimeout;
    #bufferDismissed = true;
    #bufferDuration;
    constructor(loadingAnimationContainer, config) {
        this.#loadingAnimationContainer = loadingAnimationContainer;
        this.#config = config;
        this.#utils = window.PARA.PlayerServices.Utilities;
        this.#enabled = config?.enabled;
        const defaultTimeoutForMessage = 5000;
        this.#bufferDuration = Number(config?.timeoutForMessage || defaultTimeoutForMessage);
        this.#createTimeoutMessageContainer();
    }
    get name() {
        return 'LoadingAnimationTimeoutMessage';
    }
    enable = () => {
        this.#enabled = true;
    };
    disable = () => {
        this.#enabled = false;
        this.hide();
    };
    show = () => {
        if (!this.#enabled
            || !(this.#utils.Type.isElement(this.#container))
            || !this.#bufferDismissed) {
            return;
        }
        clearTimeout(this.#bufferTimeout);
        this.#bufferTimeout = window.setTimeout(this.#showTimeoutMessage, this.#bufferDuration);
        this.#bufferDismissed = false;
    };
    hide = () => {
        if (this.#utils.Type.isElement(this.#container)) {
            this.#hideTimeoutMessage();
        }
    };
    #showTimeoutMessage = () => {
        clearTimeout(this.#bufferTimeout);
        if (this.#utils.Type.isElement(this.#container)) {
            this.#container.style.setProperty('opacity', '1', CSSValue.IMPORTANT);
        }
    };
    #hideTimeoutMessage = () => {
        this.#bufferDismissed = true;
        clearTimeout(this.#bufferTimeout);
        if (this.#utils.Type.isElement(this.#container)) {
            this.#container.style.setProperty('opacity', '0', CSSValue.IMPORTANT);
        }
    };
    #createTimeoutMessageContainer = () => {
        if (this.#config?.timeoutMessage) {
            this.#container = this.#utils.DOM.stringToElement(`
				<div
					style="	
						transform: translateY(90px);
						position: absolute;
						transition: 0.5s ease opacity;
						opacity: 0;
						color: #eee;
						font-family: 'ProximaNovaA-Regular', Verdana, sans-serif !important;
						z-index: 2;" 
					class="loading-animation-optimizing-container">
					${this.#config.timeoutMessage}
				</div>
			`);
            this.#loadingAnimationContainer?.appendChild(this.#container);
        }
    };
}
